module.exports = __webpack_public_path__ + "static/media/search-icon.f01a9ce1.svg";